"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowsWebPlayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ShowsMetadata_1 = require("../../Metadata/ShowsMetadata");
const StoryWebPlayer_1 = require("../StoryWebPlayer");
/** Spotlight Web Player should be used for displaying Spotlight content on the Web. */
function ShowsWebPlayer(props) {
    return ((0, jsx_runtime_1.jsx)(StoryWebPlayer_1.StoryWebPlayer, { currentOnPlaySnapIndex: 0, ...props, loopSnap: true, shouldTogglePlayWithFocus: true, allowReporting: false, autoPlay: true, isMuted: true, isOnPlay: !props.isMobile, children: props.customMetadataEl || (0, jsx_runtime_1.jsx)(ShowsMetadata_1.ShowsMetadata, {}) }));
}
exports.ShowsWebPlayer = ShowsWebPlayer;
//# sourceMappingURL=ShowsWebPlayer.js.map